import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'createdByLabel'
	| 'hiddenIcon'
	| 'hiddenTooltip'
	| 'templatesLozengeTitle'
	| 'chatWithAgent'
	| 'starAgentTooltip'
	| 'copyAgentLinkTooltip'
	| 'copyAgentLinkClickedTooltip';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		createdByLabel: {
			id: 'rovo-chat.browse-agents.created-by-label',
			defaultMessage: `<text>by</text> {creatorName}`,
			description:
				'Text shown on agent card to attribute creator. Displays as "by [creator name]" where {creatorName} placeholder is replaced with the actual creator\'s name.',
		},
		hiddenIcon: {
			id: 'ai-mate.agent-profile-info.hidden-icon',
			defaultMessage: 'Hidden',
			description:
				'Label text displayed on agent card next to eye icon with slash to indicate the agent is hidden from search results.',
		},
		hiddenTooltip: {
			id: 'ai-mate.agent-profile-info.hidden-tooltip',
			defaultMessage: "Agent won't show in search results",
			description:
				'Tooltip text that appears on hover/focus of the hidden icon (eye with slash). Explains that a hidden agent will not be visible in agent search results.',
		},
		templatesLozengeTitle: {
			id: 'ai-mate.agent-list.templates-lozenge-title',
			defaultMessage: 'Template',
			description:
				'Label text displayed in a colored lozenge badge on agent cards that are template agents. Indicates to users this is a pre-built agent template.',
		},
		chatWithAgent: {
			id: 'ai-mate.agent-profile-info.chat-with-agent',
			defaultMessage: 'Chat with {agentName}',
			description:
				'Button label on agent card to initiate a chat with the agent. The {agentName} placeholder is replaced with the agent\'s name (e.g., "Chat with Customer Support").',
		},
		starAgentTooltip: {
			id: 'ai-mate.agent-profile-info.star-agent-tooltip',
			defaultMessage: 'Star agent',
			description:
				'Tooltip text for the star icon button on agent card. Clicking adds/removes agent from favorites.',
		},
		copyAgentLinkTooltip: {
			id: 'ai-mate.agent-profile-info.copy-agent-link-tooltip',
			defaultMessage: 'Copy link',
			description:
				"Tooltip text for the copy link icon button on agent card. When clicked, copies the agent's URL to clipboard.",
		},
		copyAgentLinkClickedTooltip: {
			id: 'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip',
			defaultMessage: 'Copied URL',
			description:
				"Tooltip text shown briefly after user clicks copy link button, confirming the agent's URL has been copied to clipboard.",
		},
	});

export default message;
